export default function sortAppointmentsByTimeAsc(appointments) {
    return appointments.sort((a, b) => new Date(`1970/01/01 ${a.data.time}`) - new Date(`1970/01/01 ${b.data.time}`));
}
